import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceListPathParameters } from 'api/actions/remote-source-list/remote-source-list-path-parameters';
import { RemoteSourceListResponse } from 'api/actions/remote-source-list/remote-source-list-response';

type RemoteSourceListQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceList action.
 */
export const remoteSourceListActionPath = new SweetPath<keyof RemoteSourceListPathParameters>(
  '/api/remote-source/list',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceList actions.
 */
export default function createRemoteSourceListAction(axios: AxiosInstance) {
  return function remoteSourceListAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: RemoteSourceListQueryParameters } = {}) {
    const path = remoteSourceListActionPath.original;

    return axios.request<RemoteSourceListResponse, RemoteSourceListResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
